// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"270":"a615c3c1","910":"a4634e51"}[chunkId] || chunkId) + "." + {"110":"2738daf58ce2324c","134":"2ae80dbeefd9006b","228":"4f0448e86d2f369e","270":"4ef316ea88a58f5c","297":"bb3a8810d4ef3fb9","813":"91f8d7b8dd2fb53c","829":"38f4e377fdc8ec94","910":"ea5e0735bf8c6179","989":"dc58074576a24f93"}[chunkId] + ".js";
};